<template>
  <div class="pricing-table-area section-space--ptb_60 bg-gray" id="pricing">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title-wrapper text-center section-space--mb_60">
            <h2 class="section-title font-width-light wow move-up">
              How to choose the right package?
            </h2>
          </div>
        </div>
      </div>
      <PricingFour />
    </div>
  </div>
</template>

<script>
import PricingFour from "@/components/PricingFour";

export default {
  name: "ClinicPricing",
  components: {
    PricingFour,
  },
};
</script>
